import { getProfessionBusinessConfig } from "@/apis/crypto";
import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import './index.scss';
import txt from "@/assets/images/merchant/subsidy/txt.png";
import profession from "@/assets/images/merchant/subsidy/profession.png";
import logo from "@/assets/images/merchant/subsidy/logo.png";
interface MyObject {
  [key: string]: any;
}
const data = {
  sellingConfig: ({
    "bankObj": {},
    "wxAlipayObj": {}
  } as MyObject),
  config: {
    silverBusinessDepositScope: {
      min: 1,
      max: 5000
    },
    silverBusinessWechatAlipayReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    silverBusinessBankCardReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    ordinaryBusinessDepositScope: {
      min: 1,
      max: 10000
    },
    ordinaryBusinessWechatAlipayReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    ordinaryBusinessBankCardReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    platinumGoldBusinessDepositScope: {
      min: 10001,
      max: 20000
    },
    platinumGoldBusinessWechatAlipayReward: {
      min: 2,
      middle: 2,
      max: 2
    },
    platinumGoldBusinessBankCardReward: {
      min: 2,
      middle: 2,
      max: 2
    },
    diamondBusinessDepositScope: {
      min: 20001,
      max: 30000
    },
    diamondBusinessWechatAlipayReward: {
      min: 3,
      middle: 3,
      max: 3
    },
    diamondBusinessBankCardReward: {
      min: 3,
      middle: 3,
      max: 3
    },
    crownBusinessDepositScope: {
      min: 30001,
      max: 40000
    },
    crownBusinessWechatAlipayReward: {
      min: 4,
      middle: 4,
      max: 4
    },
    crownBusinessBankCardReward: {
      min: 4,
      middle: 4,
      max: 4
    }
  }
};
export const Detail = ({
  title,
  hideAlipayWechatProfessionMerchant
}: any) => {
  const [config, setConfig] = useState<any>(data.config);
  const [sellingConfig, setSellingConfig] = useState<any>(data.sellingConfig);
  const fetchBusinessConfig = async () => {
    const {
      ok,
      data,
      msg
    } = await getProfessionBusinessConfig();
    if (ok) {
      setConfig(data.business_range_config);
      let bankArr: any[] = [];
      let wxAlipayArr: any[] = [];
      let params: MyObject = {
        "bankObj": {},
        "wxAlipayObj": {}
      };
      data.business_range_config.silverBusinessWechatAlipayReward.map((val: any) => bankArr.push({
        type: "silver",
        ...val
      }));
      data.business_range_config.ordinaryBusinessWechatAlipayReward.map((val: any) => bankArr.push({
        type: "ordinary",
        ...val
      }));
      data.business_range_config.platinumGoldBusinessWechatAlipayReward.map((val: any) => bankArr.push({
        type: "platinumGold",
        ...val
      }));
      data.business_range_config.diamondBusinessWechatAlipayReward.map((val: any) => bankArr.push({
        type: "diamond",
        ...val
      }));
      data.business_range_config.crownBusinessWechatAlipayReward.map((val: any) => bankArr.push({
        type: "crown",
        ...val
      }));
      data.business_range_config.silverBusinessBankCardReward.map((val: any) => wxAlipayArr.push({
        type: "silver",
        ...val
      }));
      data.business_range_config.ordinaryBusinessBankCardReward.map((val: any) => wxAlipayArr.push({
        type: "ordinary",
        ...val
      }));
      data.business_range_config.platinumGoldBusinessBankCardReward.map((val: any) => wxAlipayArr.push({
        type: "platinumGold",
        ...val
      }));
      data.business_range_config.diamondBusinessBankCardReward.map((val: any) => wxAlipayArr.push({
        type: "diamond",
        ...val
      }));
      data.business_range_config.crownBusinessBankCardReward.map((val: any) => wxAlipayArr.push({
        type: "crown",
        ...val
      }));
      bankArr.map((val: any) => {
        if (params.wxAlipayObj.hasOwnProperty(`${val.range_start}~${val.range_end}`)) {
          params.wxAlipayObj[`${val.range_start}~${val.range_end}`][val.type] = val.subsidy_ratio;
        } else {
          params.wxAlipayObj[`${val.range_start}~${val.range_end}`] = {
            "silver": "",
            "ordinary": "",
            "platinumGold": "",
            "diamond": "",
            "crown": "",
            ...{
              [val.type]: val.subsidy_ratio
            }
          };
        }
      });
      wxAlipayArr.map((val: any) => {
        if (params.bankObj.hasOwnProperty(`${val.range_start}~${val.range_end}`)) {
          params.bankObj[`${val.range_start}~${val.range_end}`][val.type] = val.subsidy_ratio;
        } else {
          params.bankObj[`${val.range_start}~${val.range_end}`] = {
            "silver": "",
            "ordinary": "",
            "platinumGold": "",
            "diamond": "",
            "crown": "",
            ...{
              [val.type]: val.subsidy_ratio
            }
          };
        }
      });
      console.log('params===', params);
      setSellingConfig(params);
    } else {
      Toast.show(msg);
    }
  };
  useEffect(() => {
    fetchBusinessConfig();
  }, []);
  return <div className="earn_page_detail_block" data-sentry-component="Detail" data-sentry-source-file="Detail.tsx">
      <div className="earn_page_detail_title">超级商家规则与义务：</div>
      <div className="earn_page_detail_content">
        <p>
          <span className="earn_page_detail_label"> 1.超级商家规则： </span>
          您用数字货币与平台用户资金进行等额兑换，赚取平台补贴，转入数字货币按实时汇率兑换V币（V币汇率锚定CNY），商家需自行判断和承担法律风险；若触发相应风控，需自行承担相应解封、解冻的配合义务。
        </p>
        <p>
          <span className="earn_page_detail_label"> 2.超级商家义务： </span><br></br>
          <span>2.1 超级商家挂单交易中不会有买家付款凭证，需要超级商家自行通过收款账户核对是否到账，放币风险自行承担；</span><br></br>
          <span>2.2 超级商家挂单买家由系统分配，需要确保账户活跃，否则会造成停止分配买家</span><br></br>
          <span>2.3 交易过程中须做到即时处理订单，否则会受到相应处罚，不排除封禁超级商家资格、扣除保证金等。</span>
        </p>
        <p>
          <span className="earn_page_detail_label"> 3.免责声明： </span>
          {title}钱包作为知名平台，已对所有用户进行把关审核，按国际《反洗钱法》、《反恐怖法》制定相应风控措施，平台将尽最大努力监督资金安全与干净。如交易过程遇到极端不可控情形，商家有义务自行判断，遵守您所在地的法律法规，并自愿承担相应后果。
        </p>

        <div className="earn_bg_box">
           <img className="earn_logo" src={logo} alt="" />
           <div className="earn_txt"> 
              <img src={txt} alt="" />
           </div>
           <div className="earn_txt2"> 
              <img src={profession} alt="" />
           </div>
        </div>
        {/* <div className="earn_page_detail_table_header">超级商家补贴<span>（随市场和政策浮动）</span></div> */}
        <table className="earn_page_detail_table">
          <thead>
            {/* <tr>
              <th className="earn_page_detail_headLine" rowSpan={2}>
                <span className="earn_page_detail_leftBottom">变现</span>
              </th>
              <th colSpan={6}>
                <span className="earn_page_detail_rightTop">商家等级</span>
              </th>
             </tr> */}
            <tr>
              <th className="headLine">
                <span className="leftBottom">变现</span>
                <span className="rightTop">商家</span>
              </th>
              <th>
                白银
              </th>
              <th>
                黄金
              </th>
              <th>
                铂金
              </th>
              <th>
                钻石
              </th>
              <th>
                皇冠
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(sellingConfig.wxAlipayObj).map(key => {
            return <tr key={key} style={{
              display: !hideAlipayWechatProfessionMerchant ? 'table-row' : 'none'
            }}>
                <td>
                  微信/支付宝 <br />
                  <span>区间{key}</span>
                </td>
                <td>{isNaN(parseFloat(sellingConfig.wxAlipayObj[key].silver)) ? "--" : `${sellingConfig.wxAlipayObj[key].silver}%`}</td>
                <td>{isNaN(parseFloat(sellingConfig.wxAlipayObj[key].ordinary)) ? "--" : `${sellingConfig.wxAlipayObj[key].ordinary}%`}</td>
                <td>{isNaN(parseFloat(sellingConfig.wxAlipayObj[key].platinumGold)) ? "--" : `${sellingConfig.wxAlipayObj[key].platinumGold}%`}</td>
                <td>{isNaN(parseFloat(sellingConfig.wxAlipayObj[key].diamond)) ? "--" : `${sellingConfig.wxAlipayObj[key].diamond}%`}</td>
                <td>{isNaN(parseFloat(sellingConfig.wxAlipayObj[key].crown)) ? "--" : `${sellingConfig.wxAlipayObj[key].crown}%`}</td>
              </tr>;
          })}
            {Object.keys(sellingConfig.bankObj).map(key => {
            return <tr key={key}>
                <td>
                  银行卡 <br />
                  <span>区间{key}</span>
                </td>
                <td>{isNaN(parseFloat(sellingConfig.bankObj[key].silver)) ? "--" : `${sellingConfig.bankObj[key].silver}%`}</td>
                <td>{isNaN(parseFloat(sellingConfig.bankObj[key].ordinary)) ? "--" : `${sellingConfig.bankObj[key].ordinary}%`}</td>
                <td>{isNaN(parseFloat(sellingConfig.bankObj[key].platinumGold)) ? "--" : `${sellingConfig.bankObj[key].platinumGold}%`}</td>
                <td>{isNaN(parseFloat(sellingConfig.bankObj[key].diamond)) ? "--" : `${sellingConfig.bankObj[key].diamond}%`}</td>
                <td>{isNaN(parseFloat(sellingConfig.bankObj[key].crown)) ? "--" : `${sellingConfig.bankObj[key].crown}%`}</td>
              </tr>;
          })}
            <tr>
              <td><span>保证金</span></td>
              <td>{config.silverBusinessDepositScope.min}U起</td>
              <td>{config.ordinaryBusinessDepositScope.min}U起</td>
              <td>{config.platinumGoldBusinessDepositScope.min}U起</td>
              <td>{config.diamondBusinessDepositScope.min}U起</td>
              <td>{config.crownBusinessDepositScope.min}U起</td>
            </tr>
          </tbody>

        </table>
      </div>
    </div>;
};